<h3>API endpoint</h3>
<p>{{environment.aiWebServerUrl}}task/{{task.id}}</p>
<small>Authentication required. Pass an API key through the X-API-Key header.</small>

<h3>Run task manually</h3>
<!-- Add a textbox for payload and a button for running the test -->
<mat-form-field appearance="fill" class="full-width w-100">
    <mat-label>Test data</mat-label>
    <textarea matInput [(ngModel)]="payload" placeholder="Add test data here" rows="5"></textarea>
</mat-form-field>
<button mat-raised-button color="primary" type="button" (click)="runTest()" [disabled]="isRunning">
    {{ isRunning ? 'Running...' : 'Test' }}
</button>


@if (runningTask && !(runningTask.updateMessages.length > 1)) {
    <div>
    <p>Waiting for available worker. This could take up to 60 seconds.</p>
    </div>
}
@if (runningTask) {
    @for (message of runningTask.updateMessages; track message) {
        <div>
            <p>{{ message }}</p>
    </div>
    }
}


@if (responseText && responseText.length > 0) {
    <div>
    <h3>Response</h3>
    <div [innerHtml]="responseText"></div>
    </div>
}

@if (responseAudio && responseAudio.length > 0) {
    <div>
    <h3>Audio Response</h3>
    <audio controls [src]="responseAudio"></audio>
    </div>
}